module.exports = __webpack_public_path__ + "static/img/clickin4.a2de260b.png";